import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const FETCH_INTEGRATIONS = 'FETCH_INTEGRATIONS'
const FETCH_INTEGRATION = 'FETCH_INTEGRATION'

export const getIntegrationsApi = apiCall(
  FETCH_INTEGRATIONS,
  ({ siteId }: { siteId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/integrations`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)

export const getIntegrationApi = apiCall(
  FETCH_INTEGRATION,
  ({ siteId, provider }: { siteId: string; provider: string }) => ({
    endpoint: getApiUrl(
      `/api/cms/v1/sites/${siteId}/integrations/${provider}`,
    ),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)
